module.exports = __webpack_public_path__ + "img/horizontal_4_3_r_9006.7282ac1e.png";